import { render, staticRenderFns } from "./PlayerVideoCard.vue?vue&type=template&id=b123f6ea&scoped=true"
import script from "./PlayerVideoCard.vue?vue&type=script&lang=js"
export * from "./PlayerVideoCard.vue?vue&type=script&lang=js"
import style0 from "./PlayerVideoCard.vue?vue&type=style&index=0&id=b123f6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123f6ea",
  null
  
)

export default component.exports